import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { AuthService } from './auth.service';
import { ConfigService } from './config.service';
import { WindowRefService } from './window-ref.service';

@Injectable({ providedIn: 'root' })
export class PanoramaService {

  onSituViewLoad = new ReplaySubject<void>();
  situSystems: any;
  window: any;

  constructor(private configService: ConfigService, windowRef: WindowRefService, private authService: AuthService) {
    this.addSituViewTag();
    this.window = windowRef.nativeWindow;
  }

  addSituViewTag() {
    this.onSituViewLoad = new ReplaySubject<void>();

    if (document.getElementById("SituViewScript") != null) {
      if (!this.situSystems) {
        this.situSystems = this.window["SituSystems"];
      }

      this.onSituViewLoad.next();
      return;
    }

    let tag = document.createElement('script');
    tag.src = this.configService.config.situViewJsUrl.toString();
    tag.type = 'text/javascript';
    tag.id = "SituViewScript"
    tag.addEventListener("load", () => {
      this.situSystems = this.window["SituSystems"];
      this.onSituViewLoad.next();
    });

    let firstScriptTag = document.getElementsByTagName('script')[0];
    if (firstScriptTag?.parentNode) {
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
    else{
      let head = document.getElementsByTagName('head')[0];
      firstScriptTag.prepend(tag);
    }
  }

  createPluginManager() {
    let pluginManager = new this.situSystems.PluginManager();
    pluginManager.authorizationHeaderValue = this.authService.getAuthorizationHeaderValue();
    pluginManager.init()
    return pluginManager;
  }
}
